import axios from 'axios'

export function uploadCoverImage(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function getAvailableAdditionalOrderParticipantAttributes() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/-actions/available-additional-order-participant-attributes', {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function createProduct(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function createProductWithSessions(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/-actions/store-product-with-sessions', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function addSessionToProduct(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-product-sessions', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function updateSession(id, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-product-sessions/'+ id, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function removeSession(id) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-product-sessions/' + id, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        }
    })
}
export function getProductSessionById(productId, id) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId + '/-actions/get-product?session_id=' + id, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}


export function getCurrencies() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/currencies', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getStoreProducts(spaceID, archived = false, page, size, sortLastCreated) {
    let sort_params = ''
    if (sortLastCreated) {
        sort_params = '&sort=-created_at'
    }

    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-products?filter[archived]=' + archived + '&page[size]=' + size + '&page[number]=' + page + sort_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function searchStoreProducts(spaceID, archived = false, searchTerm, page, size, sortLastCreated) {
    searchTerm = encodeURIComponent(searchTerm)

    let sort_params = ''
    if (sortLastCreated) {
        sort_params = '&sort=-created_at'
    }

    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-products?filter[archived]=' + archived  + '&page[size]=' + size + '&page[number]=' + page + '&filter[product]=' + searchTerm + sort_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getStoreProduct(productId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getProductSessions(productId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId + '/sessions', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function updateProduct(productId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getStoreProductPublic(productId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId + '/-actions/get-product', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createOrder(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getStoreOrders(spaceID, page, size, status, sortLastCreated) {
    let filter_params = ''
    if (status) {
        filter_params = '&filter[status]=' + status
    }

    let sort_params = ''
    if (sortLastCreated) {
        sort_params = '&sort=-created_at'
    }

    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-orders?page[size]=' + size + '&page[number]=' + page + filter_params + sort_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function searchStoreOrders(spaceID, searchTerm, page, size, status, sortLastCreated) {
    searchTerm = encodeURIComponent(searchTerm)
    let filter_params = ''
    if (status) {
        filter_params = '&filter[status]=' + status
    }

    let sort_params = ''
    if (sortLastCreated) {
        sort_params = '&sort=-created_at'
    }

    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-orders?page[size]=' + size + '&page[number]=' + page + '&filter[order]=' + searchTerm + filter_params + sort_params, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getStoreOrder(orderID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + orderID, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function approveDenyOrder(orderID, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + orderID + '/-actions/approve-order', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function getStoreSettings(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-settings', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getStorePurchasePolicy(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/-actions/get-store-purchase-policy', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function createStoreSettings(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-settings', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function updateStoreSettings(data, storeId) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-settings/' + storeId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function createCustomer(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-customers', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getStoreCustomers(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-customers?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function searchStoreCustomers(spaceID, searchTerm, page, size) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-customers?page[size]=' + size + '&page[number]=' + page + '&filter[customer]=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getStoreCustomer(customerID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-customers/' + customerID, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function deleteProduct(productId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getStoreOrdersAll(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-orders', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getStoreOrderUsersStatistics(orderID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + orderID + '/-actions/get-users-statistics', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function createCustomerContact(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-customer-contacts', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getStoreOrderPublic(orderID, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + orderID + '/-actions/get-order', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getStoreOrderUsersStatisticsPublic(orderID, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + orderID + '/-actions/get-users-statistics-public', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}
export function getStoreCustomerConatcts(customerID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-customers/' + customerID + '/store-customer-contacts', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function downloadOrderDataPublic(orderID, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + orderID + '/-actions/download-statistics-public', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
        responseType: 'blob',
    })
}
export function downloadOrderData(orderID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + orderID + '/-actions/download-statistics', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
        responseType: 'blob',
    })
}
export function searchCustomer(spaceID, keyword) {
    keyword = encodeURIComponent(keyword)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/store-customers?filter[customer]=' + keyword, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function addToCustomer(userID, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + userID, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getStoreOrdersCustomer(customerID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-customers/' + customerID + '/store-orders', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function downloadInvoiceOrderData(orderID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-orders/' + orderID + '/-actions/download-invoice', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
        responseType: 'blob',
    })
}

export function getStoreProductOverview(productId, startDate, endDate, currency = 'SEK') {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId + '/-actions/product-overview?dateStart=' + startDate + '&dateEnd=' + endDate + '&currency=' + currency, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getStoreOverview(spaceID, startDate, endDate, currency = 'SEK') {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/-actions/store-overview?dateStart=' + startDate + '&dateEnd=' + endDate + '&currency=' + currency, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function uploadParticipantFile(productId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId + '/-actions/doc-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function fetchFile(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/-actions/doc-fetch', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function duplicateProduct(productId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/store-products/' + productId + '/-actions/duplicate', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

